import { FaLightbulb, FaHandshake, FaShieldAlt } from 'react-icons/fa';
import { company } from '../data';
import { Container, PageHero, Reveal, SectionHead } from '../components/ui';

const values = [
  { icon: FaLightbulb, t: 'Innovation', d: 'We constantly push boundaries and explore new ideas to stay ahead of industry trends.' },
  { icon: FaHandshake, t: 'Collaboration', d: 'We believe in the power of teamwork and partnership to achieve extraordinary results.' },
  { icon: FaShieldAlt, t: 'Integrity', d: 'We conduct business with transparency, honesty, and the highest ethical standards.' },
];

const AboutUs = ({ go }) => (
  <>
    <PageHero
      eyebrow="About us"
      title="About Our Company"
      text="We're a dedicated team of professionals committed to delivering exceptional solutions that help our clients succeed in today's competitive landscape."
    />

    <section className="py-20 md:py-24">
      <Container className="grid lg:grid-cols-2 gap-12">
        <Reveal>
          <SectionHead eyebrow="Who we are" title="Our Story" />
          <div className="mt-6 space-y-4 text-slate-600 text-lg">
            <p>Established in 2000, Anuryan Marketing &amp; Services (Now Anuryan E &amp; A) has been a trusted partner for industrial automation and switchgear solutions for over two decades. We bring expertise and innovation to a diverse range of industries, empowering our clients to optimize their operations and achieve peak performance.</p>
            <p>At Anuryan, we are committed to providing our clients with exceptional service and support. We strive to build long-term relationships based on trust, reliability, and a deep understanding of their business needs. Our team of experienced professionals is dedicated to delivering innovative solutions that exceed expectations and drive lasting value.</p>
          </div>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="grid grid-cols-2 gap-4">
            {[[`${new Date().getFullYear() - company.founded}+`, 'years of experience'], [String(company.founded), 'year founded'], ['4', 'core services'], ['Kolkata', 'headquarters']].map(([n, l]) => (
              <div key={l} className="rounded-2xl bg-mist border border-slate-200 p-6">
                <p className="font-display font-bold text-3xl text-secondary">{n}</p>
                <p className="text-sm text-slate-600 mt-1">{l}</p>
              </div>
            ))}
          </div>
        </Reveal>
      </Container>
    </section>

    <section className="py-20 bg-ink grid-bg text-white">
      <Container>
        <Reveal><SectionHead light eyebrow="What we stand on" title="Our Core Values" /></Reveal>
        <div className="mt-12 grid md:grid-cols-3 gap-6">
          {values.map(({ icon: Icon, t, d }, i) => (
            <Reveal key={t} delay={i * 0.08}>
              <div className="h-full rounded-2xl bg-panel border border-white/10 p-7">
                <span className="grid place-items-center w-11 h-11 rounded-lg bg-primary/15 text-primary"><Icon /></span>
                <h3 className="font-display font-semibold text-xl mt-5">{t}</h3>
                <p className="text-white/65 mt-2">{d}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </Container>
    </section>

    <section className="pb-20 md:pb-24 pt-16">
      <Container>
        <div className="rounded-2xl bg-gradient-to-r from-secondary to-primary text-white p-8 md:p-10 flex flex-wrap items-center justify-between gap-6">
          <h3 className="font-display font-bold text-2xl md:text-3xl">Ready to work with us?</h3>
          <button onClick={() => go('contact')} className="rounded-full bg-white text-secondary font-semibold px-7 py-3 hover:bg-mist transition">Get in touch</button>
        </div>
      </Container>
    </section>
  </>
);

export default AboutUs;
